// Import and register all controllers from the controllers directory
import { application } from "./application"

// Auto-register all controllers in this directory
const context = require.context(".", true, /_controller\.js$/)
context.keys().forEach((key) => {
  const controllerName = key
    .replace(/^\.\//, "")  // Remove leading ./
    .replace(/_controller\.js$/, "")  // Remove _controller.js suffix
    .replace(/\//g, "-")  // Replace / with - for nested controllers
    .replace(/_/g, "-")  // Replace _ with - for kebab-case
  
  const module = context(key)
  const controller = module.default || module
  
  application.register(controllerName, controller)
})
